var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu11(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.875,
    height: 27,
    viewBox: "0 0 16.875 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-actor-2488620",
    transform: "translate(13 -89.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11_Star_Actor",
    "data-name": "11 Star Actor",
    transform: "translate(-25 89)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9491",
    "data-name": "Path 9491",
    d: "M20.844,6.75h8.438a.844.844,0,0,0,.844-.844V1.688a.844.844,0,0,0-1.312-.7l-1.829,1.22L25.765.376a.844.844,0,0,0-1.4,0l-1.22,1.829L21.312.986a.844.844,0,0,0-1.312.7V5.907A.844.844,0,0,0,20.844,6.75Zm.844-3.486,1.22.813a.844.844,0,0,0,1.17-.234l.986-1.478.986,1.477a.844.844,0,0,0,1.17.234l1.22-.811v1.8h-6.75Z",
    transform: "translate(-4.625)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9492",
    "data-name": "Path 9492",
    d: "M23.741,28.8a5.906,5.906,0,1,0-6.607,0A8.449,8.449,0,0,0,12,36.559a.844.844,0,0,0,.844.844H28.031a.844.844,0,0,0,.844-.844A8.449,8.449,0,0,0,23.741,28.8ZM16.219,23.9a4.219,4.219,0,1,1,4.219,4.219A4.219,4.219,0,0,1,16.219,23.9ZM13.74,35.716a6.75,6.75,0,0,1,13.4,0Z",
    transform: "translate(0 -10.403)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu11);
export default __webpack_public_path__ + "static/media/menu-11.4f60e9d3f7c480acda1f5813f1a73815.svg";
export { ForwardRef as ReactComponent };